"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_USER_DATA_FORMAT_SETTINGS = exports.USER_DATA_FORMAT_MAX_DIGITS = exports.USER_DATA_FORMAT_MIN_DIGITS = exports.USER_DATA_FORMAT_UNIT_ALIAS_MAP = exports.USER_DATA_FORMAT_PROFILE_UNITS = exports.USER_DATA_FORMAT_MANUAL_INPUT_UNIT_CODE = exports.USER_DATA_FORMAT_DECIMAL_SEPARATOR = exports.USER_DATA_FORMAT_MODE = void 0;
exports.cloneDefaultUserDataFormatSettings = cloneDefaultUserDataFormatSettings;
exports.resolveUserDataFormatUnitKey = resolveUserDataFormatUnitKey;
exports.normalizeUserDataFormatSettings = normalizeUserDataFormatSettings;
exports.getUserDataFormatRule = getUserDataFormatRule;
exports.applyUserDataFormatDecimalSeparator = applyUserDataFormatDecimalSeparator;
exports.formatNumberByUserDataFormat = formatNumberByUserDataFormat;
exports.formatNumberByUserDataFormatOrFallback = formatNumberByUserDataFormatOrFallback;
exports.USER_DATA_FORMAT_MODE = {
    FIXED: "fixed",
    FLOATING: "floating",
};
exports.USER_DATA_FORMAT_DECIMAL_SEPARATOR = {
    DOT: "dot",
    COMMA: "comma",
};
exports.USER_DATA_FORMAT_MANUAL_INPUT_UNIT_CODE = "manualInput";
const USER_DATA_FORMAT_UNIT_DEFAULTS = [
    { code: "0", defaultDigits: 2 },
    { code: "1", defaultDigits: 2 },
    { code: "2", defaultDigits: 2 },
    { code: "5", defaultDigits: 2 },
    { code: "6", defaultDigits: 1 },
    { code: exports.USER_DATA_FORMAT_MANUAL_INPUT_UNIT_CODE, defaultDigits: 2 },
    { code: "128", defaultDigits: 2 },
    { code: "129", defaultDigits: 1 },
    { code: "130", defaultDigits: 1 },
    { code: "132", defaultDigits: 1 },
    { code: "133", defaultDigits: 0 },
    { code: "134", defaultDigits: 1 },
    { code: "135", defaultDigits: 2 },
    { code: "139", defaultDigits: 2 },
    { code: "140", defaultDigits: 1 },
    { code: "141", defaultDigits: 2 },
];
exports.USER_DATA_FORMAT_PROFILE_UNITS = [
    {
        code: "0",
        labelIntlId: "pages.profile.dataFormatUnitAcceleration",
        defaultLabel: "Acceleration, m/s2",
        defaultDigits: 2,
    },
    {
        code: "1",
        labelIntlId: "pages.profile.dataFormatUnitVelocity",
        defaultLabel: "Velocity, mm/s",
        defaultDigits: 2,
    },
    {
        code: "2",
        labelIntlId: "pages.profile.dataFormatUnitDisplacement",
        defaultLabel: "Displacement, μm",
        defaultDigits: 2,
    },
    {
        code: "5",
        labelIntlId: "pages.profile.dataFormatUnitTime",
        defaultLabel: "Time, s",
        defaultDigits: 2,
    },
    {
        code: "6",
        labelIntlId: "pages.profile.dataFormatUnitRevolutions",
        defaultLabel: "Revolutions",
        defaultDigits: 1,
    },
    {
        code: exports.USER_DATA_FORMAT_MANUAL_INPUT_UNIT_CODE,
        labelIntlId: "pages.profile.dataFormatUnitManualInput",
        defaultLabel: "Manual input",
        defaultDigits: 2,
    },
    {
        code: "128",
        labelIntlId: "pages.profile.dataFormatUnitCustom",
        defaultLabel: "Custom",
        defaultDigits: 2,
    },
    {
        code: "129",
        labelIntlId: "pages.profile.dataFormatUnitExcess",
        defaultLabel: "Excess",
        defaultDigits: 1,
    },
    {
        code: "130",
        labelIntlId: "pages.profile.dataFormatUnitPercent",
        defaultLabel: "Percent",
        defaultDigits: 1,
    },
    {
        code: "132",
        labelIntlId: "pages.profile.dataFormatUnitLogarithmic",
        defaultLabel: "Logarithmic, dB",
        defaultDigits: 1,
    },
    {
        code: "133",
        labelIntlId: "pages.profile.dataFormatUnitPhase",
        defaultLabel: "Phase, deg",
        defaultDigits: 0,
    },
    {
        code: "134",
        labelIntlId: "pages.profile.dataFormatUnitPeak",
        defaultLabel: "Peak",
        defaultDigits: 1,
    },
    {
        code: "135",
        labelIntlId: "pages.profile.dataFormatUnitFrequencyHz",
        defaultLabel: "Frequency, Hz",
        defaultDigits: 2,
    },
    {
        code: "139",
        labelIntlId: "pages.profile.dataFormatUnitFrequencyHarmonic",
        defaultLabel: "Frequency, harmonic",
        defaultDigits: 2,
    },
    {
        code: "140",
        labelIntlId: "pages.profile.dataFormatUnitRpm",
        defaultLabel: "Revolutions per minute",
        defaultDigits: 1,
    },
    {
        code: "141",
        labelIntlId: "pages.profile.dataFormatUnitTemperature",
        defaultLabel: "Temperature, °C",
        defaultDigits: 2,
    },
];
exports.USER_DATA_FORMAT_UNIT_ALIAS_MAP = {
    "3": "135",
    "4": "139",
    "142": "141",
    "143": "141",
};
exports.USER_DATA_FORMAT_MIN_DIGITS = 0;
exports.USER_DATA_FORMAT_MAX_DIGITS = 10;
exports.DEFAULT_USER_DATA_FORMAT_SETTINGS = {
    decimalSeparator: exports.USER_DATA_FORMAT_DECIMAL_SEPARATOR.DOT,
    units: Object.fromEntries(USER_DATA_FORMAT_UNIT_DEFAULTS.map(({ code, defaultDigits }) => [
        code,
        { mode: exports.USER_DATA_FORMAT_MODE.FIXED, digits: defaultDigits },
    ])),
};
function cloneDefaultUserDataFormatSettings() {
    return {
        decimalSeparator: exports.DEFAULT_USER_DATA_FORMAT_SETTINGS.decimalSeparator,
        units: Object.fromEntries(Object.entries(exports.DEFAULT_USER_DATA_FORMAT_SETTINGS.units).map(([key, rule]) => [key, { ...rule }])),
    };
}
function isPlainObject(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
function isDataFormatMode(value) {
    return value === exports.USER_DATA_FORMAT_MODE.FIXED || value === exports.USER_DATA_FORMAT_MODE.FLOATING;
}
function isDecimalSeparator(value) {
    return value === exports.USER_DATA_FORMAT_DECIMAL_SEPARATOR.DOT || value === exports.USER_DATA_FORMAT_DECIMAL_SEPARATOR.COMMA;
}
function clampDigits(value, fallback) {
    const parsed = typeof value === "number" ? value : Number(value);
    if (!Number.isFinite(parsed)) {
        return fallback;
    }
    return Math.max(exports.USER_DATA_FORMAT_MIN_DIGITS, Math.min(exports.USER_DATA_FORMAT_MAX_DIGITS, Math.trunc(parsed)));
}
function resolveUserDataFormatUnitKey(unitCode) {
    if (unitCode === null || unitCode === undefined || unitCode === "") {
        return null;
    }
    const key = String(unitCode);
    if (Object.prototype.hasOwnProperty.call(exports.DEFAULT_USER_DATA_FORMAT_SETTINGS.units, key)) {
        return key;
    }
    const alias = exports.USER_DATA_FORMAT_UNIT_ALIAS_MAP[key];
    if (alias && Object.prototype.hasOwnProperty.call(exports.DEFAULT_USER_DATA_FORMAT_SETTINGS.units, alias)) {
        return alias;
    }
    return null;
}
function normalizeUserDataFormatSettings(raw) {
    const normalized = cloneDefaultUserDataFormatSettings();
    if (!isPlainObject(raw)) {
        return normalized;
    }
    if (isDecimalSeparator(raw.decimalSeparator)) {
        normalized.decimalSeparator = raw.decimalSeparator;
    }
    if (!isPlainObject(raw.units)) {
        return normalized;
    }
    for (const [unitCode, rule] of Object.entries(raw.units)) {
        const resolvedUnitCode = resolveUserDataFormatUnitKey(unitCode);
        if (!resolvedUnitCode || !isPlainObject(rule)) {
            continue;
        }
        const fallbackRule = normalized.units[resolvedUnitCode];
        normalized.units[resolvedUnitCode] = {
            mode: isDataFormatMode(rule.mode) ? rule.mode : fallbackRule.mode,
            digits: clampDigits(rule.digits, fallbackRule.digits),
        };
    }
    return normalized;
}
function getUserDataFormatRule(settings, unitCode) {
    const resolvedUnitCode = resolveUserDataFormatUnitKey(unitCode);
    if (!resolvedUnitCode) {
        return null;
    }
    const normalizedSettings = normalizeUserDataFormatSettings(settings);
    return (normalizedSettings.units[resolvedUnitCode] ?? exports.DEFAULT_USER_DATA_FORMAT_SETTINGS.units[resolvedUnitCode] ?? null);
}
function trimTrailingZeros(value) {
    if (!value.includes(".")) {
        return value;
    }
    const trimmed = value.replace(/(\.\d*?[1-9])0+$/u, "$1").replace(/\.0+$/u, "");
    return trimmed === "-0" ? "0" : trimmed;
}
function removeNegativeZero(value) {
    return Number(value) === 0 ? value.replace(/^-/, "") : value;
}
function applyUserDataFormatDecimalSeparator(value, settings) {
    const normalizedSettings = normalizeUserDataFormatSettings(settings);
    if (normalizedSettings.decimalSeparator === exports.USER_DATA_FORMAT_DECIMAL_SEPARATOR.COMMA) {
        return value.replace(".", ",");
    }
    return value;
}
function formatNumberByUserDataFormat(value, unitCode, settings) {
    if (!Number.isFinite(value)) {
        return null;
    }
    const rule = getUserDataFormatRule(settings, unitCode);
    if (!rule) {
        return null;
    }
    const normalizedSettings = normalizeUserDataFormatSettings(settings);
    let formatted = removeNegativeZero(value.toFixed(rule.digits));
    if (rule.mode === exports.USER_DATA_FORMAT_MODE.FLOATING) {
        formatted = trimTrailingZeros(formatted);
    }
    formatted = applyUserDataFormatDecimalSeparator(formatted, normalizedSettings);
    return formatted;
}
function formatNumberByUserDataFormatOrFallback(value, unitCode, settings, options = {}) {
    if (value === null || value === undefined || !Number.isFinite(value)) {
        return "";
    }
    const formattedBySettings = formatNumberByUserDataFormat(value, unitCode, settings);
    if (formattedBySettings !== null) {
        return formattedBySettings;
    }
    const fallbackDigits = options.fallbackDigits ?? 2;
    const fallbackValue = trimTrailingZeros(Number(value).toFixed(fallbackDigits));
    return applyUserDataFormatDecimalSeparator(fallbackValue, settings);
}
//# sourceMappingURL=user-data-format.js.map